export default {
  title: "Verify Your Email",
  verifying: {
    title: "Verifying Your Email",
    subtitle: "Please wait while we verify your email address...",
  },
  sending: {
    title: "Sending Verification Email",
    subtitle: "Please wait while we send the verification email...",
  },
  sent: {
    title: "Verification Email Sent",
    confirmationMessage: {
      beforeEmail: "We've sent a confirmation link to ",
      afterEmail: "",
    },
    instruction: "Please check your inbox and click the link to activate your account",
    troubleMessage: "Didn’t receive the email? Check your spam folder or click “Resend” below",
    limitNote: "Note: You can resend the verification email up to 3 times per day",
  },
  resent: {
    title: "Verification Email Resent",
    confirmationMessage: {
      beforeEmail: "We've resent the confirmation link to ",
      afterEmail: "",
    },
    instruction: "Please check your inbox and click the link to activate your account",
    troubleMessage: "If still not received, check spam/junk or try again later",
    limitNote: "Note: You can resend the verification email up to 3 times per day",
  },
  success: {
    title: "Email Verified Successfully",
    subtitle: "Your email has been verified. You can now log in to your account.",
    button: "Go to Login",
    autoRedirectMessage: "Redirecting to dashboard in {seconds} seconds...",
  },
  error: {
    title: "Email Verification Failed",
    subtitle: "An error occurred during verification. Please try again later.",
    button: "Back to Login",
  },
  resending: "Resending...",
  resendAvailableIn: "Resend available in {seconds}s",
  resendVerificationEmail: "Resend Verification Email",
  verificationFailed: "Email verification failed",
  verificationError: "An error occurred during email verification",
  pleaseWait: "Please wait {seconds} seconds before resending",
  dailyLimitReached: "Daily resend limit reached. Try again tomorrow.",
  resentSuccess: "Verification email resent successfully",
  resendFailed: "Failed to resend verification email",
  invalidRequest: "Invalid request",
  remainingAttempts: "You have {count} attempts remaining today",
};
